import {Component, inject} from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from '../../../environments/environment';
import {brand} from '../../settings/marqueblanche';

@Component({
  selector: 'app-iackathon-wrapper',
    imports: [
        MatProgressSpinner
    ],
  templateUrl: './iackathon-wrapper.component.html',
  styleUrl: './iackathon-wrapper.component.scss',
})
export class IackathonWrapperComponent {
    private sanitizer = inject(DomSanitizer);

    private readonly token = localStorage.getItem('http_accessToken');
    protected url = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.iackathonUrl(brand)}?token=${this.token.slice(1, -1)}`);
}
